export default "__VITE_ASSET__Dmr2s0u8__"